export default {
    createPlace: 'สร้างสถานที่',
    updatePlace: 'แก้ไขสถานที่',
    namePlace: 'ชื่อสถานที่',
    latitude: 'ละติจูด',
    longitude: 'ลองจิจูด',
    radian: 'รัศมี (เมตร)',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    save: 'บันทึก',
    congratulation: 'ยินดีด้วย',
    placeIsUpdated: 'สถานที่ถูกอัปเดตแล้ว',
    placeIsCreated: 'สถานที่ถูกสร้างแล้ว'
}
